import { AngularFirestore } from '@angular/fire/compat/firestore';
import { BlockService } from './../../services/block.service';
import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-blocks',
  templateUrl: './blocks.page.html',
  styleUrls: ['./blocks.page.scss'],
})
export class BlocksPage implements OnInit {

  blockArray = [];

  constructor(
    private blockService: BlockService,
    private fireStore: AngularFirestore,
    public authService: AuthenticationService,
    public router: Router,
    ) { }

  ngOnInit() {
    this.authService.login();
    this.onListBlocks();
  }

  ionViewWillEnter() {
    if (this.authService.isLoggedIn === false) {
      this.router.navigateByUrl('/admin/login');
    }
  }

  onListBlocks() {
    const list = this.blockService.loadLiveList();
    list.valueChanges({idField: 'id'}).subscribe((ss) => {
      this.blockArray = ss;
      // console.log(this.pageArray);
    });
  }

  onDelete(id: string) {
    this.blockService.deleteBlock(id);
  }
}
